import FilmsSliderLazyContainer from './FilmsSliderLazyContainer';
export default FilmsSliderLazyContainer;
